/**
 * Axios封装
 * 需求 npm install axios
 *
 * 默认错误信息加载element-ui
 * 需求 npm install element-ui
 *
 * Java可以配合 Luminous-Tool 的 WebResponse 类否则需要重写  processResponse() 方法
 *
 * BaseUrl 请求根地址
 *
 * @author 冰糕Luminous
 */

import axios from 'axios';
import {Notification} from 'element-ui';
import router from "@/components/router";

const BaseUrl = 'https://v1.blendermagic.cn';

// const BaseUrl = 'http://127.0.0.1:30000';

axios.defaults.withCredentials = true;

export default class AxiosBase {

    /**
     * Get请求
     * @param url 请求接口地址
     * @param paramSetting 请求设置
     */
    static axiosGet(url, paramSetting) {
        return axios.get(BaseUrl + url, paramSetting).then((response) => {
            return this.processResponse(response.data)
        }).catch((error) => {
            return this.ajaxError(error);
        })
    }

    /**
     * Post请求
     * @param url 请求接口地址
     * @param paramSetting 请求设置
     */
    static axiosPost(url, paramSetting) {
        return axios.post(BaseUrl + url, paramSetting).then((response) => {
            return this.processResponse(response.data);
        }).catch((error) => {
            return this.ajaxError(error);
        })
    }

    /**
     * Put请求
     * @param url 请求接口地址
     * @param paramSetting 请求设置
     */
    static axiosPut(url, paramSetting) {
        return axios.put(BaseUrl + url, paramSetting).then((response) => {
            return this.processResponse(response.data);
        }).catch((error) => {
            return this.ajaxError(error);
        })
    }

    /**
     * Delete请求
     * @param url 请求接口地址
     * @param paramSetting 请求设置
     */
    static axiosDelete(url, paramSetting) {
        return axios.delete(BaseUrl + url, paramSetting).then((response) => {
            return this.processResponse(response.data);
        }).catch((error) => {
            return this.ajaxError(error);
        })
    }

    /**
     * 处理Ajax错误
     * @param error 错误信息
     */
    static ajaxError(error) {
        Notification.error({
            title: '出错了（；´д｀）ゞ',
            message: '无法连接到服务器:' + error
        });
        return 0;
    }

    /**
     * 处理返回结果
     * @param response 返回的Response
     * @returns {*} Response的data
     */
    static processResponse(response) {
        if (response.code === 200) {
            return response;
        } else {
            this.showErrorMsg(response);
        }
        return 0;
    }

    static showErrorMsg(response) {
        console.log(response.data);
        if (response.code === 201) {
            Notification.error({
                title: '出错了（；´д｀）ゞ',
                message: response.data
            });
        } else if (response.code === 500) {
            console.log(response.data);
            Notification.error({
                title: '出错了（；´д｀）ゞ',
                message: response.remark
            });
        } else if (response.code === 501) {
            Notification.error({
                title: '登陆状态已过期（；´д｀）ゞ',
                message: response.remark
            });
            router.push("/login").then(() => {
            });
        } else if (response.code === 503) {
            Notification.error({
                title: '你没有权限执行此操作（；´д｀）ゞ',
                message: ""
            });
        } else {
            console.log(response.data);
            Notification.error({
                title: '出错了（；´д｀）ゞ',
                message: '服务器君在处理请求时发生意料之外的错误,错误信息:' + response.data + "(" + response.remark + ")"
            });
        }
    }
}

